import * as React from 'react';

import PartDetailsDesktop from 'src/components/PartDetails/PartDetailsDesktop';
import PartDetailsMobile from 'src/components/PartDetails/PartDetailsMobile';
import TopProductCardsCarousel from 'src/components/TopProductCardsCarousel';
import ShippingToChange from 'src/components/ShippingToChange/ShippingToChange';
import Alert from 'src/components/common/Alert';
import Modal from 'src/components/common/Modal';

import { IPart } from 'src/components/PartDetails/PartDetailsDesktop/PartDetailsDesktop';
import { IWarehouse, IAddress } from 'src/model/productdetails.model';
import { IWarrantyProvider } from 'src/model/warranty.model';
import LocationModel from 'src/model/location.model';
import AddressModel from 'src/model/address.model';
import OneTimeAddressModel from 'src/model/oneTimeAddress.model';

import productServiceInstance from 'src/services/products/ProductService';
import cartService from 'src/services/cart/CartService';
import userService from 'src/services/user/userService';

import './PartView.scss';
import { isMobile } from '../../utils/responsiveHelpers';
import Breadcrumbs from 'src/components/common/Breadcrumbs';
import ProductShipFromModal from 'src/components/common/ProductShipFromModal';
import ProductPickUpModal from 'src/components/common/ProductPickUpModal';
import { linkLocationsToWarehouses } from 'src/utils/partsBusinessLogic';
import { goToCart, cartUrl, goToLogin } from 'src/utils/navigation';
import ProductManufacturer from 'src/model/productManufacturer.model';
import Loader from 'src/components/common/Loader';
import { startEndWithWhiteSpacesValidation } from 'src/utils/whiteSpacesValidation';
import env from 'src/shared/env';
import locationServiceInstance from 'src/services/location/LocationService';
import i18n from 'src/translation/i18n';
import { ImageAspectRatio } from '@material-ui/icons';
import UserModel from 'src/model/user.model';

function parsePartNumber(
  pn: string
): { mfc: string; name: string; orgPartnum?: string; orgPartmfc?: string } {
  pn = decodeURIComponent(pn);

  const split = pn.split('  ');

  if (split.length > 1) {
    // if (split.length === 4) {
    //   const mfc = split[0];
    //   // split.shift();
    //   const name = split[1];
    //   const orgPartnum = split[3];
    //   const orgPartmfc = split[2];
    //   return {
    //     mfc,
    //     name,
    //     orgPartmfc,
    //     orgPartnum
    //   };
    // } else {
    // Get mfc as first part of the string
    const mfc = split[0];
    // Get name by concat all remaining parts
    split.shift();
    const name = split.join('  ');
    // console.log(name,'name');
    return {
      mfc,
      name
    };
    // }
  }

  return {
    mfc: null,
    name: pn
  };
}

interface IPartViewProps {
  match?: any;
  t?: any;
  updateCart: () => void;
  cartItemsCount: number;
  fireProductDetailEvent: (data: any) => void;
  fireProductAddedToCartEvent: (data: any) => void;
  userData: UserModel;
}

interface IPartViewState {
  isLoadingPartDetails: boolean;
  isLoadingAddToCart: boolean;
  part: IPart;
  manufacturers: ProductManufacturer[];
  selectedManufacturer: ProductManufacturer;
  qty: number;
  shipmentMarking: string;
  ticketNumber: string;
  warrantyProvider: string;
  warrantyProviderCode: string;
  claims: string;
  backorder: boolean;
  rushOrder: boolean;
  deliverMethod: string;
  deliverMethodtab: string;
  cartDeliverMethod: string;
  // cartDeliveryLocation: any;
  cartDeliveryLocationCode: string;
  shipFromOrder: object;
  shipsToCode: string;
  oneTimeAddress: OneTimeAddressModel | null;
  pickUpFromOrder: object;
  pickUpToCode: string;
  shippingList: {
    warehouses: IWarehouse[];
    locations: LocationModel[];
    defaultWarehouse: any;
    shippingList: any[];
    pickUpList: any[];
    deliverList: any[];
    allPickupList: any[];
  };
  showChangeShipTo: boolean;
  showChangeDeliverMethod: { noPickUpList: boolean; pickUpOnly: boolean };
  showChangePickUp: boolean;
  isMobile: boolean;
  showCartAlert: boolean;
  cartAlertType: string;
  notFound: boolean;
  shipmentMarkingAlert: boolean;
  ticketNumberAlert: boolean;
  dispatchClaimAlert: boolean;
  cartAlertMessage: string;
  showChangeDeliveryAlertModal: boolean;
  changeDeliveryMessage: any;
  isAddedToCart: boolean;
  resetPickUpAction: () => void;
  lastShipAddress: string;
  orgPartnum: string;
  orgPartmfc: string;
  deliveryFromOrder: object;
  deliverToCode: string;
  invalidAddressEncounter: boolean;
  errorMessage: string;
}

export class PartView extends React.Component<IPartViewProps, IPartViewState> {
  public myLongDescRef: any;
  constructor(props: any) {
    super(props);
    this.myLongDescRef = React.createRef();
    this.state = this.initialState();
  }

  private initialState = (): IPartViewState => {
    return {
      isLoadingPartDetails: true,
      isLoadingAddToCart: false,
      errorMessage: '',
      part: {
        images: [],
        modelsFound: 0,
        name: '',
        notes: '',
        productNumber: '',
        description: '',
        price: 0,
        msrp: 0,
        inStock: false,
        supplierQuantity: 0,
        state: '',
        stateDescription: '',
        extraProducts: [],
        extraTotalAmount: 0,
        pickUpFrom: '',
        pickUpTo: '',
        shipFrom: '',
        shipToName: '',
        shipToAddress: '',
        manufacturer: '',
        manufacturerCode: '',
        replacedPart: null,
        replacedMfc: null,
        specialOrder: false,
        isDropShip: false,
        discountInfo: null,
        orderDetailStatus: '',
        deliveryFrom: '',
        deliveryTo: '',
        alternateParts: [],
        longDesc: '',
        subPartNumber: '',
        weight: '0',
        length: '0',
        width: '0',
        height: '0',
        category: ''
      },
      manufacturers: [],
      selectedManufacturer: null,
      qty: 1,
      shipmentMarking: '',
      ticketNumber: '',
      warrantyProvider: '',
      warrantyProviderCode: '',
      claims: '',
      backorder: false,
      rushOrder: false,
      deliverMethod: '',
      deliverMethodtab: '',
      cartDeliverMethod: '',
      cartDeliveryLocationCode: '',
      shipFromOrder: {},
      shipsToCode: '',
      oneTimeAddress: null,
      pickUpFromOrder: {},
      pickUpToCode: '',
      shippingList: {
        warehouses: [],
        locations: [],
        defaultWarehouse: {},
        shippingList: [],
        pickUpList: [],
        deliverList: [],
        allPickupList: []
      },
      showChangeShipTo: false,
      showChangeDeliverMethod: { noPickUpList: false, pickUpOnly: false },
      showChangePickUp: false,
      isMobile: isMobile(),
      showCartAlert: false,
      cartAlertType: '',
      notFound: false,
      shipmentMarkingAlert: false,
      ticketNumberAlert: false,
      dispatchClaimAlert: false,
      cartAlertMessage: '',
      showChangeDeliveryAlertModal: false,
      changeDeliveryMessage: { title: '', message: '', address: '' },
      isAddedToCart: false,
      resetPickUpAction: () => {
        return;
      },
      lastShipAddress: '',
      orgPartmfc: '',
      orgPartnum: '',
      deliveryFromOrder: {},
      deliverToCode: '',
      invalidAddressEncounter: false
    };
  };

  private setResetPickUpAction = (fn: () => void) => {
    this.setState({
      resetPickUpAction: fn
    });
  };

  private getSupplierQuantity = (warehouses: IWarehouse[]): number => {
    let quantity = 0;
    if (warehouses) {
      warehouses.forEach(warehouse => {
        if (warehouse && warehouse.description === 'Supplier Quantity') {
          quantity = warehouse.quantity;
        }
      });
    }
    return quantity;
  };

  private getShipFromInfo = (
    warehouses: IWarehouse[],
    locations: LocationModel[],
    deliverMethod: string
  ): string => {
    let desc = 'No warehouses available.';
    let defaultWarehouseDescription = '';
    let defaultWarehouseCode = '';
    let defaultWarehouse: any = {};
    let defaultWarehouseQty = 0;
    let first = false;
    let firstLocationWithStock = '';
    let firstLocationWithStockQty = 0;
    let firstLocationWithStockCode = '';
    const list: any[] = linkLocationsToWarehouses(warehouses, locations);
    const noPickUplist: any[] = [];
    list.forEach(element => {
      if (!element.pickUpOnly) {
        noPickUplist.push(element);
      }
    });
    noPickUplist.forEach(warehouse => {
      if (warehouse.warehouseCode && warehouse.default) {
        defaultWarehouse = warehouse;
        defaultWarehouseDescription = warehouse.description;
        defaultWarehouseCode = warehouse.warehouseCode;
        defaultWarehouseQty = warehouse.quantity;
      }
      if (warehouse.warehouseCode && warehouse.quantity > 0 && !first) {
        firstLocationWithStock = warehouse.description;
        firstLocationWithStockCode = warehouse.warehouseCode;
        firstLocationWithStockQty = warehouse.quantity;
        first = true;
      }
    });

    if (defaultWarehouseDescription) {
      this.setState(prevState => ({
        shipFromOrder: {
          [defaultWarehouseCode]: { qty: 1, available: defaultWarehouseQty }
        },
        shippingList: {
          ...this.state.shippingList,
          warehouses,
          locations,
          defaultWarehouse,
          shippingList: noPickUplist
        },
        backorder:
          defaultWarehouseQty < 1 && deliverMethod === 'shipping'
            ? true
            : prevState.backorder
      }));
      desc = defaultWarehouseDescription;
    } else {
      this.setState({
        shipFromOrder: {
          [firstLocationWithStockCode]: {
            qty: 1,
            available: firstLocationWithStockQty
          }
        },
        shippingList: {
          ...this.state.shippingList,
          warehouses,
          locations,
          defaultWarehouse,
          shippingList: noPickUplist
        }
      });
      desc = firstLocationWithStock;
    }

    this.getPickUpAddresses();

    return desc;
  };

  private getPickUpInfo = (
    cartPickUpCode: string,
    warehouses: IWarehouse[],
    locations: LocationModel[],
    deliverMethod: string
  ): string => {
    let defaultWarehouseDescription = '';
    let defaultWarehouseCode = '';
    let defaultWarehouseQty = 0;
    let cartPickUpDescription = '';
    let pickUpCode = '';
    const location = '';
    let quantity = 0;
    const list: any[] = linkLocationsToWarehouses(warehouses, locations);
    list.forEach(warehouse => {
      // search for cart pick up
      if (
        warehouse.warehouseCode &&
        warehouse.warehouseCode === cartPickUpCode
      ) {
        const str = warehouse.description;
        const n = str.search(' PICK UP ONLY');
        quantity = warehouse.quantity;
        pickUpCode = warehouse.warehouseCode;
        if (n > 0) {
          cartPickUpDescription = str.slice(0, n + 1);
        } else {
          cartPickUpDescription = warehouse.description;
        }
      }
      // search for default warehouse
      if (warehouse.warehouseCode && warehouse.default) {
        const str = warehouse.description;
        const n = str.search(' PICK UP ONLY');
        quantity = warehouse.quantity;
        if (n > 0) {
          defaultWarehouseDescription = str.slice(0, n + 1);
        } else {
          defaultWarehouseDescription = warehouse.description;
        }
        defaultWarehouseQty = warehouse.quantity;
        defaultWarehouseCode = warehouse.warehouseCode;
      }
    });

    if (cartPickUpDescription) {
      this.setState(prevState => ({
        pickUpFromOrder: { [pickUpCode]: { qty: 1, available: quantity } },
        pickUpToCode: pickUpCode,
        shippingList: {
          ...prevState.shippingList,
          pickUpList: list,
          allPickupList: list
        }
      }));
      return cartPickUpDescription;
    } else if (defaultWarehouseDescription) {
      this.setState(prevState => ({
        pickUpFromOrder: {
          [defaultWarehouseCode]: { qty: 1, available: defaultWarehouseQty }
        },
        pickUpToCode: defaultWarehouseCode,
        shippingList: {
          ...prevState.shippingList,
          pickUpList: list,
          allPickupList: list
        },
        backorder:
          defaultWarehouseQty < 1 &&
          (deliverMethod === 'pick-up' || deliverMethod === 'delivery')
            ? true
            : prevState.backorder
      }));
      return defaultWarehouseDescription;
    } else {
      this.setState(prevState => ({
        pickUpFromOrder: { [pickUpCode]: { qty: 1, available: quantity } },
        pickUpToCode: pickUpCode,
        shippingList: {
          ...prevState.shippingList,
          pickUpList: list,
          allPickupList: list
        }
      }));
    }
    return location;
  };

  private getDeliveryInfo = (
    cartDeliveryCode: string,
    warehouses: IWarehouse[],
    locations: LocationModel[],
    deliverMethod: string
  ): string => {
    let defaultWarehouseDescription = '';
    let defaultWarehouseCode = '';
    let defaultWarehouseQty = 0;
    let cartDeliveryDescription = '';
    let deliveryCode = '';
    const location = '';
    let quantity = 0;
    const list: any[] = linkLocationsToWarehouses(warehouses, locations);
    list.forEach(warehouse => {
      if (
        warehouse.warehouseCode &&
        warehouse.warehouseCode === cartDeliveryCode
      ) {
        const str = warehouse.description;
        const n = str.search(' PICK UP ONLY');
        quantity = warehouse.quantity;
        deliveryCode = warehouse.warehouseCode;
        if (n > 0) {
          cartDeliveryDescription = str.slice(0, n + 1);
        } else {
          cartDeliveryDescription = warehouse.description;
        }
      }
      // search for default warehouse
      if (warehouse.warehouseCode && warehouse.default) {
        const str = warehouse.description;
        quantity = warehouse.quantity;
        defaultWarehouseDescription = warehouse.description;
        defaultWarehouseQty = warehouse.quantity;
        defaultWarehouseCode = warehouse.warehouseCode;
      }
    });

    if (cartDeliveryDescription) {
      this.setState(prevState => ({
        deliveryFromOrder: { [deliveryCode]: { qty: 1, available: quantity } },
        deliverToCode: deliveryCode,
        shippingList: {
          ...prevState.shippingList,
          deliverList: list
        }
      }));
      return cartDeliveryDescription;
    } else if (defaultWarehouseDescription) {
      this.setState(prevState => ({
        deliveryFromOrder: {
          [defaultWarehouseCode]: { qty: 1, available: defaultWarehouseQty }
        },
        deliverToCode: defaultWarehouseCode,
        shippingList: {
          ...prevState.shippingList,
          deliverList: list
        },
        backorder:
          defaultWarehouseQty < 1 && deliverMethod === 'delivery'
            ? true
            : prevState.backorder
      }));
      return defaultWarehouseDescription;
    } else {
      this.setState(prevState => ({
        deliveryFromOrder: { [deliveryCode]: { qty: 1, available: quantity } },
        deliverToCode: deliveryCode,
        shippingList: {
          ...prevState.shippingList,
          deliverList: list
        }
      }));
    }
    return location;
  };

  private formatAddress = (address: LocationModel) => {
    return address
      ? `${
          address.addressLine1
            ? `${address.addressLine1.toLocaleLowerCase()}, `
            : ''
        }${
          address.addressLine2
            ? `${address.addressLine2.toLocaleLowerCase()}, `
            : ''
        }${
          address.addressLine4
            ? `${address.addressLine4.toLocaleLowerCase()}, `
            : ''
        }${address.stateCode ? `${address.stateCode} ` : ''}${
          address.postalCode ? `${address.postalCode}` : ''
        }`
      : '';
  };

  private onSelectMfc = (item: ProductManufacturer) => {
    if (
      this.state.selectedManufacturer &&
      item &&
      this.state.selectedManufacturer.manufacturerCode === item.manufacturerCode
    ) {
      // No changes, do nothing;
      return;
    }
    this.setState(
      {
        selectedManufacturer: item,
        isLoadingPartDetails: true
      },
      () => {
        // Get only part details and don't reload MFC to keep current list
        // In case we are loading a substitute
        this.getPartDetails(item.productNumber, item.manufacturerCode);
      }
    );
  };

  private getAddresses = async (
    postalCode: string,
    list: any[],
    value?: boolean
  ) => {
    const newAddresses: any[] = [];

    await locationServiceInstance
      .getLocations(postalCode, value)
      .then(addresses => {
        addresses.forEach(location => {
          list.forEach((address: any) => {
            if (address.code === location.code) {
              newAddresses.push({ ...address, ...location });
            }
          });
        });
      });

    return newAddresses;
  };

  private getPartDetails = async (pn?: string, mfc?: string) => {
    let name = '';
    let manufacturer = '';
    let deliverMethod: '' | 'shipping' | 'pick-up' | 'delivery' = '';
    let defaultAddress: any = null;
    if (pn) {
      name = pn;
      manufacturer = mfc;
    } else {
      const parsed = parsePartNumber(this.props.match.params.partNumber);
      name = parsed.name;
      manufacturer = parsed.mfc;
      this.setState({
        orgPartnum: parsed.orgPartnum,
        orgPartmfc: parsed.orgPartmfc
      });
    }
    let shippingAddressValid=false;
    await cartService.getCartShippingAddress().then(r => {
      defaultAddress = r;
      shippingAddressValid=true;
    }).catch(error => {
        if(error.response.status===404){
          shippingAddressValid=false;
          // this.renderAddressNotFound();
        }
    });
   
if(shippingAddressValid){
    {/* Get values from local Storage */} 
    return productServiceInstance
      .getProductDetails(name, manufacturer)
      .then(res => {
        // Store part no in session storage for Alt Parts Brandcrumb
        let getFromStorage=sessionStorage.getItem("bredcrumbKey");

        if(res.alternateProductsList.length>0 && getFromStorage===""){
          getFromStorage=getFromStorage+"=="+manufacturer+"  "+name;
          sessionStorage.setItem("bredcrumbKey", getFromStorage);
        }

        if (res.available === false) {
          return new Promise((resolve, _) => {
            this.setState(
              {
                isLoadingPartDetails: false,
                notFound: true,
                errorMessage: 'The requested part is currently unavailable. We apologize for the inconvenience.'
              },
              () => resolve()
            );
          });
        } else {
          return cartService.getCartBasicInfo().then(async r => {
            let pickUpAddresses: any[] = [];
            let shippingAddresses: any[] = [];
            let deliveryAddresses: any[] = [];

            if (r.delivery === 'Delivery') {
              deliveryAddresses = await this.getAddresses(
                res.locations[0].postalCode,
                res.locations,
                true
              );
              deliverMethod = 'delivery';
            } else if (r.delivery === 'Shipping') {
              deliverMethod = 'shipping';
              shippingAddresses = await this.getAddresses(
                r.deliveryLocation.postalCode,
                res.locations
              );
            } else if (r.delivery === 'Pick-Up') {
              deliverMethod = 'pick-up';
              const index = res.locations.findIndex(l => {
                return l.code === r.deliveryLocationCode;
              });

              pickUpAddresses = await this.getAddresses(
                res.locations[index].postalCode,
                res.locations,
                false
              );
            }

            const pickUp = this.getPickUpInfo(
              r.deliveryLocationCode,
              res.warehouses,
              deliverMethod === 'pick-up' ? pickUpAddresses : res.locations,
              deliverMethod
            );

            const pickUpFilteredAddresses = this.getDeliveryInfo(
              r.deliveryLocationCode,
              res.warehouses,
              pickUpAddresses,
              deliverMethod
            );

            let deliverInfo: any;

            if (this.props.userData.isDelivery) {
              deliveryAddresses = await this.getAddresses(
                res.locations[0].postalCode,
                res.locations,
                true
              );
              deliverInfo = this.getDeliveryInfo(
                this.props.userData.warehouseInfo.code,
                res.warehouses,
                deliveryAddresses,
                deliverMethod
              );
            }
            /* Get New storage Rresponse from API */
            
            /* CLar Old One */
            /* Strore new One */
            
            const part: IPart = {
              images: res.images,
              modelsFound: res.modelsNumberTotalFound,
              name: res.name,
              notes:res.notes,
              productNumber: res.productNumber,
              description: res.description,
              price: res.partnerPrice,
              msrp: res.retailPrice,
              inStock: res.inStock,
              supplierQuantity: this.getSupplierQuantity(res.warehouses),
              state: res.state,
              stateDescription: res.stateDescription,
              extraProducts: res.extraProducts,
              extraTotalAmount: res.extraTotalAmount,
              pickUpFrom: pickUpFilteredAddresses,
              pickUpTo: pickUp,
              shipFrom: this.getShipFromInfo(
                res.warehouses,
                deliverMethod === 'shipping'
                  ? shippingAddresses
                  : res.locations,
                deliverMethod
              ),
              shipToName:
                deliverMethod === 'shipping'
                  ? r.deliveryLocation
                    ? r.deliveryLocation.name
                    : ''
                  : defaultAddress.deliveryLocation.name,
              shipToAddress:
                deliverMethod === 'shipping'
                  ? r.deliveryLocation
                    ? this.formatAddress(r.deliveryLocation)
                    : ''
                  : this.formatAddress(defaultAddress.deliveryLocation),
              manufacturer: res.manufacturer,
              manufacturerCode: res.manufacturerCode,
              replacedPart: res.replacedPart,
              replacedMfc: res.replacedMfc,
              specialOrder: res.specialOrder,
              isDropShip: res.isDropShip,
              discountInfo: res.discountInfo,
              orderDetailStatus: res.orderDetailStatus,
              replacementMfc: res.replacementMfc,
              replacementPart: res.replacementPart,
              alternateproductnumber: res.alternateProductNumber,
              alternatemfc: res.alternateProductManufacturer,
              oemProductNumber: res.oemProductNumber,
              oemProductManufacturer: res.oemProductManufacturer,
              // oempartnumapi:null,
              // oempartmfcapi:null
              deliveryFrom: deliverInfo,
              deliveryTo: deliverInfo,
              alternateParts: res.alternateProductsList,
              longDesc: res.longDesc,
              subPartNumber: res.subPartNumber,
              weight: res.weight,
              length: res.length,
              width: res.width,
              height: res.height,
              category: res.category
            };
            return new Promise((resolve, _) => {
              this.setState(
                {
                  isLoadingPartDetails: false,
                  notFound: false,
                  part,
                  deliverMethodtab: deliverMethod,
                  deliverMethod,
                  shipsToCode:
                    deliverMethod === 'shipping'
                      ? r.deliveryLocation
                        ? r.deliveryLocationCode
                        : ''
                      : defaultAddress.code,
                  cartDeliverMethod: deliverMethod,
                  cartDeliveryLocationCode: r.deliveryLocationCode
                },
                () => resolve()
              );
            });
          });
        }
      })
      .catch(err => {
        console.error('Part Details Error:', err);

        const status = err?.response?.status;

        if (status === 404) {
          // Part not found
          this.setState({
            isLoadingPartDetails: false,
            notFound: true,
            errorMessage: 'There were no results for your search. The page you are looking for doesn’t exist or has been moved'
          });
        } else if (status === 500) {
          // Server error
          this.setState({
            isLoadingPartDetails: false,
            notFound: true,
            errorMessage: 'Server connection error. Please refresh your page or check back later.'
          });

          // Show server error message
        } else if (err?.request && !err?.response) {
          this.setState({
            isLoadingPartDetails: false,
            notFound: true,
            errorMessage: 'Unable to connect to the server. Please check your internet connection.'
          });
         } else if (err instanceof TypeError) {
          // Network error
          console.error('Application Error:', err.message);
          this.setState({
            isLoadingPartDetails: false,
            notFound: true,
            errorMessage: 'The selected location is no longer available. We apologize for the inconvenience.'
          });

          // Show network error message
        } else {
          // Other errors
          this.setState({
            isLoadingPartDetails: false,
            notFound: true,
            errorMessage: 'An unknow error has occurred. If you require assistance, please contact Customer Service at 800-666-0313.'
          });

          // Show generic error message
        }
      });
  }else{
    this.setState({
      isLoadingPartDetails: false,
      invalidAddressEncounter: true
    });
  }  
  };

  private getMfc(pn?: string) {
    let name = '';
    if (pn) {
      name = pn;
    } else {
      const parsed = parsePartNumber(this.props.match.params.partNumber);
      name = parsed.name;
    }
    this.setState({ isLoadingAddToCart: true });
    return productServiceInstance
      .getProductManufacturers(name)
      .then(res => {
        this.setState({ isLoadingAddToCart: false });
        const selectedManufacturer = res.find(mfg => {
          return mfg.manufacturerCode === this.state.part.manufacturerCode;
        });
        if (selectedManufacturer) {
          this.setState({
            manufacturers: res,
            selectedManufacturer
          });
        } else {
          this.setState({
            manufacturers: res,
            selectedManufacturer: res[0]
          });
        }
      })
      .catch(err => {
        console.error(err);
        // Not a critical error.
      });
  }

  private handleQtyChange = (qty: any) => {
    qty = Number(qty);
    if (this.state.deliverMethod === 'shipping') {
      const selectedWarehouses = Object.keys(this.state.shipFromOrder);
      if (selectedWarehouses.length > 1) {
        this.handleChangeShipFrom({
          [this.state.shippingList.defaultWarehouse.warehouseCode]: {
            qty
          }
        });
      } else {
        this.handleChangeShipFrom({
          [selectedWarehouses[0]]: {
            qty
          }
        });
      }
    }
  };

  private handleShipmentMarkingChange = (shipmentMarking: string) => {
    if (
      !shipmentMarking ||
      (shipmentMarking !== ' ' &&
        !startEndWithWhiteSpacesValidation(shipmentMarking))
    ) {
      this.setState({
        shipmentMarking
      });

      if (shipmentMarking.length === 30) {
        this.setState({
          shipmentMarkingAlert: true
        });
      } else {
        this.setState({
          shipmentMarkingAlert: false
        });
      }
    }
  };

  private handleTicketNumberChange = (ticketNumber: string) => {
    if (
      !ticketNumber ||
      (ticketNumber !== ' ' && !startEndWithWhiteSpacesValidation(ticketNumber))
    ) {
      this.setState({
        ticketNumber
      });

      if (ticketNumber.length === 10) {
        this.setState({
          ticketNumberAlert: true
        });
      } else {
        this.setState({
          ticketNumberAlert: false
        });
      }
    }
  };

  private handleWarrantyProviderChange = (warranty: IWarrantyProvider) => {
    this.setState({
      warrantyProviderCode: warranty.providerNumberString,
      warrantyProvider: warranty.warrantyClaimNumber
    });
  };

  private handleClaimsChange = (claims: string) => {
    if (
      !claims ||
      (claims !== ' ' && !startEndWithWhiteSpacesValidation(claims))
    ) {
      this.setState({
        claims
      });

      if (claims.length > 15) {
        this.setState({
          dispatchClaimAlert: true
        });
      } else {
        this.setState({
          dispatchClaimAlert: false
        });
      }
    }
  };

  private handleRushOrderChange = (rushOrder: boolean) => {
    this.setState({
      rushOrder
    });
  };

  private handleDeliverMethodChange = (
    deliveryMethod: 'shipping' | 'pick-up' | 'delivery'
  ) => {
    let backorder = false;
    if (deliveryMethod === 'pick-up') {
      for (const key in this.state.pickUpFromOrder) {
        if (this.state.pickUpFromOrder.hasOwnProperty(key)) {
          if (
            Number(this.state.pickUpFromOrder[key].qty) >
            Number(this.state.pickUpFromOrder[key].available)
          ) {
            backorder = true;
          }
        }
      }
    } else if (deliveryMethod === 'delivery') {
      for (const key in this.state.deliveryFromOrder) {
        if (this.state.deliveryFromOrder.hasOwnProperty(key)) {
          if (
            Number(this.state.deliveryFromOrder[key].qty) >
            Number(this.state.deliveryFromOrder[key].available)
          ) {
            backorder = true;
          }
        }
      }
    } else {
      for (const key in this.state.shipFromOrder) {
        if (this.state.shipFromOrder.hasOwnProperty(key)) {
          if (
            Number(this.state.shipFromOrder[key].qty) >
            Number(this.state.shipFromOrder[key].available)
          ) {
            backorder = true;
          }
        }
      }
    }

    this.setState({
      deliverMethod: deliveryMethod,
      deliverMethodtab: deliveryMethod,
      backorder
    });
  };

  private handleShowChangeShipFrom = () => {
    let list: any[] = [];
    let noPickUplist: any[] = [];
    if (this.state.shippingList.shippingList.length === 0) {
      list = linkLocationsToWarehouses(
        this.state.shippingList.warehouses,
        this.state.shippingList.locations
      );
      list.forEach(element => {
        if (!element.pickUpOnly) {
          noPickUplist.push(element);
        }
      });
    } else {
      noPickUplist = [...this.state.shippingList.shippingList];
    }
    this.setState({
      showChangeDeliverMethod: { noPickUpList: true, pickUpOnly: false }
    });
    window.scrollTo(0, 0);
  };

  private handleShowChangeShipTo = () => {
    this.setState(prevState => ({
      showChangeShipTo: !prevState.showChangeShipTo
    }));
  };

  private handleShowChangePickUp = () => {
    this.setState(prevState => {
      return {
        showChangeDeliverMethod: { noPickUpList: false, pickUpOnly: false },
        showChangePickUp: !prevState.showChangePickUp
      };
    });

    window.scrollTo(0, 0);
  };

  private handleCloseChangeDeliverMethod = () => {
    this.setState({
      showChangeDeliverMethod: { noPickUpList: false, pickUpOnly: false }
    });
  };

  private handleChangeShipFrom = (selectedAddresses: object) => {
    const newAddresses: string[] = [];
    let qty: number = 0;
    let backorder: boolean = false;
    this.state.shippingList.shippingList.forEach(address => {
      if (selectedAddresses.hasOwnProperty(address.warehouseCode)) {
        selectedAddresses[address.warehouseCode] = {
          ...selectedAddresses[address.warehouseCode],
          available: address.quantity
        };
        if (address.addressLine4) {
          newAddresses.push(
            `${address.addressLine4.toLocaleLowerCase()} ${address.stateCode}`
          );
        } else {
          newAddresses.push(`${address.name}`);
        }
      }
    });
    for (const key in selectedAddresses) {
      if (selectedAddresses.hasOwnProperty(key)) {
        qty += Number(selectedAddresses[key].qty);
        if (
          Number(selectedAddresses[key].qty) >
          Number(selectedAddresses[key].available)
        ) {
          backorder = true;
        }
      }
    }
    this.setState(prevState => ({
      part: { ...prevState.part, shipFrom: newAddresses.join(', ') },
      showChangeDeliverMethod: { noPickUpList: false, pickUpOnly: false },
      shipFromOrder: selectedAddresses,
      qty,
      backorder,
      deliverMethod: 'shipping'
    }));
  };

  private handleChangePickUp = (pickUpAddressCode: string) => {
    let newPickUpAddress: string = '';
    const list: any[] = linkLocationsToWarehouses(
      this.state.shippingList.warehouses,
      this.state.shippingList.locations
    );
    list.forEach(address => {
      if (address.warehouseCode === pickUpAddressCode) {
        if (address.addressLine4) {
          newPickUpAddress = `${address.addressLine4.toLocaleLowerCase()} ${
            address.stateCode
          }`;
        } else {
          newPickUpAddress = `${address.name}`;
        }
      }
    });
    this.setState(
      prevState => ({
        part: {
          ...prevState.part,
          pickUpTo: newPickUpAddress
        },
        pickUpToCode: pickUpAddressCode,
        showChangePickUp: false,
        pickUpFromOrder: {},
        deliverMethod: 'pick-up'
      }),
      () => {
        this.getPickUpAddresses();
      }
    );
  };

  private getAddressesAfterFirstRender = (
    postalCode: string,
    list: any[],
    callback: (newAddresses: any[]) => void,
    isPickUpOrDelivery?: boolean,
    warehouseCode?: string
  ) => {
    this.setState({
      isLoadingPartDetails: true
    });
    const newAddresses: any[] = [];

    locationServiceInstance
      .getLocations(postalCode, isPickUpOrDelivery, warehouseCode)
      .then(addresses => {
        addresses.forEach(location => {
          list.forEach(address => {
            if (address.warehouseCode === location.code) {
              newAddresses.push({ ...address, ...location });
            }
          });
        });
        callback(newAddresses);
      })
      .catch(() => {
        this.setState({
          isLoadingPartDetails: false
        });
      });
  };

  private getAddressesAfterFirstRenderForDelivery = (
    postalCode: string,
    list: any[],
    callback: (newAddresses: any[]) => void
  ) => {
    this.setState({
      isLoadingPartDetails: true
    });
    const newAddresses: any[] = [];

    locationServiceInstance
      .getLocations(postalCode, true)
      .then(addresses => {
        addresses.forEach(location => {
          list.forEach(address => {
            if (address.warehouseCode === location.code) {
              newAddresses.push({ ...address, ...location });
            }
          });
        });
        callback(newAddresses);
      })
      .catch(() => {
        this.setState({
          isLoadingPartDetails: false
        });
      });
  };

  private getPickUpAddresses = () => {
    const index = this.state.shippingList.allPickupList.findIndex(
      p => this.state.pickUpToCode === p.warehouseCode
    );

    const postalCode: string = this.state.shippingList.allPickupList[index]
      .postalCode;
    this.getAddressesAfterFirstRender(
      postalCode,
      this.state.shippingList.allPickupList,
      (newAddresses: any[]) => {
        this.setState(
          {
            shippingList: {
              ...this.state.shippingList,
              pickUpList: newAddresses
            },
            isLoadingPartDetails: false
          },
          () => {
            this.state.resetPickUpAction();
          }
        );
      },
      false,
      this.state.pickUpToCode
    );
  };

  private getShipFromAddresses = () => {
    const [strMatched] = this.state.part.shipToAddress.match(/\w{2}\s\d{4,5}/g);
    const postalCode = strMatched.split(' ')[1];
    this.getAddressesAfterFirstRender(
      postalCode,
      this.state.shippingList.shippingList,
      (newAddresses: any[]) => {
        this.setState(
          {
            shippingList: {
              ...this.state.shippingList,
              shippingList: newAddresses
            },
            isLoadingPartDetails: false
          },
          () => {
            this.state.resetPickUpAction();
          }
        );
      }
    );
  };

  private getDeliveryAddresses = () => {
    const postalCode: string = this.state.shippingList.deliverList[0]
      .postalCode;
    this.getAddressesAfterFirstRenderForDelivery(
      postalCode,
      this.state.shippingList.deliverList,
      (newAddresses: any[]) => {
        this.setState(
          {
            shippingList: {
              ...this.state.shippingList,
              pickUpList: newAddresses
            },
            isLoadingPartDetails: false
          },
          () => {
            this.state.resetPickUpAction();
          }
        );
      }
    );
  };

  private handlePickUpSuppliedFromChange = (shipFromAddress: object) => {
    let newShipFromAddresses: string = '';
    let qty: number = 0;
    let backorder: boolean = false;
    const list: any[] = linkLocationsToWarehouses(
      this.state.shippingList.warehouses,
      this.state.shippingList.locations
    );
    list.forEach(address => {
      if (shipFromAddress.hasOwnProperty(address.warehouseCode)) {
        shipFromAddress[address.warehouseCode] = {
          ...shipFromAddress[address.warehouseCode],
          available: address.quantity
        };
        if (address.addressLine4) {
          newShipFromAddresses = `${address.addressLine4.toLocaleLowerCase()} ${
            address.stateCode
          }`;
        } else {
          newShipFromAddresses = `${address.name}`;
        }
      }
    });
    for (const key in shipFromAddress) {
      if (shipFromAddress.hasOwnProperty(key)) {
        qty += Number(shipFromAddress[key].qty);
        if (
          Number(shipFromAddress[key].qty) >
          Number(shipFromAddress[key].available)
        ) {
          backorder = true;
        }
      }
    }
    this.setState(prevState => ({
      part: {
        ...prevState.part,
        pickUpFrom: newShipFromAddresses
          ? newShipFromAddresses
          : prevState.part.pickUpFrom
      },
      pickUpFromOrder: shipFromAddress,
      showChangePickUp: false,
      qty,
      backorder,
      deliverMethod: 'pick-up'
    }));
  };

  private handleDeliverySuppliedFromChange = (deliverFromAddress: object) => {
    let newDeliverFromAddresses: string = '';
    let qty: number = 0;
    let backorder: boolean = false;
    const list: any[] = linkLocationsToWarehouses(
      this.state.shippingList.warehouses,
      this.state.shippingList.locations
    );
    list.forEach(address => {
      if (deliverFromAddress.hasOwnProperty(address.warehouseCode)) {
        deliverFromAddress[address.warehouseCode] = {
          ...deliverFromAddress[address.warehouseCode],
          available: address.quantity
        };
        if (address.addressLine4) {
          newDeliverFromAddresses = `${address.addressLine4.toLocaleLowerCase()} ${
            address.stateCode
          }`;
        } else {
          newDeliverFromAddresses = `${address.name}`;
        }
      }
    });
    for (const key in deliverFromAddress) {
      if (deliverFromAddress.hasOwnProperty(key)) {
        qty += Number(deliverFromAddress[key].qty);
        if (
          Number(deliverFromAddress[key].qty) >
          Number(deliverFromAddress[key].available)
        ) {
          backorder = true;
        }
      }
    }
    this.setState(prevState => ({
      part: {
        ...prevState.part,
        deliveryFrom: newDeliverFromAddresses
          ? newDeliverFromAddresses
          : prevState.part.pickUpFrom
      },
      deliveryFromOrder: deliverFromAddress,
      showChangePickUp: false,
      qty,
      backorder,
      deliverMethod: 'delivery'
    }));
  };

  private handleDeliveryChange = (shipFromAddress: object) => {
    let newShipFromAddresses: string = '';
    let qty: number = 0;
    let backorder: boolean = false;
    const list: any[] = linkLocationsToWarehouses(
      this.state.shippingList.warehouses,
      this.state.shippingList.locations
    );
    list.forEach(address => {
      if (shipFromAddress.hasOwnProperty(address.warehouseCode)) {
        shipFromAddress[address.warehouseCode] = {
          ...shipFromAddress[address.warehouseCode],
          available: address.quantity
        };
        if (address.addressLine4) {
          newShipFromAddresses = `${address.addressLine4.toLocaleLowerCase()} ${
            address.stateCode
          }`;
        } else {
          newShipFromAddresses = `${address.name}`;
        }
      }
    });
    for (const key in shipFromAddress) {
      if (shipFromAddress.hasOwnProperty(key)) {
        qty += Number(shipFromAddress[key].qty);
        if (
          Number(shipFromAddress[key].qty) >
          Number(shipFromAddress[key].available)
        ) {
          backorder = true;
        }
      }
    }
    this.setState(prevState => ({
      part: {
        ...prevState.part,
        deliveryFrom: newShipFromAddresses
          ? newShipFromAddresses
          : prevState.part.pickUpFrom
      },
      deliveryFromOrder: shipFromAddress,
      showChangePickUp: false,
      qty,
      backorder,
      deliverMethod: 'delivery'
    }));
  };

  private handleChangeShipTo = (
    address: AddressModel,
    oneTimeddress: boolean
  ): void => {
    if (oneTimeddress) {
      this.setState(prevState => ({
        part: {
          ...prevState.part,
          shipToAddress: `${
            address.addressLine1
              ? `${address.addressLine1.toLocaleLowerCase()}, `
              : ''
          }${
            address.addressLine2
              ? `${address.addressLine2.toLocaleLowerCase()}, `
              : ''
          }${
            address.addressLine3
              ? `${address.addressLine3.toLocaleLowerCase()}, `
              : ''
          }${
            address.addressLine4
              ? `${address.addressLine4.toLocaleLowerCase()}, `
              : ''
          }${address.stateCode ? `${address.stateCode} ` : ''}${
            address.postalCode ? `${address.postalCode}` : ''
          }`.toLowerCase(),
          shipToName: address.name,
          shipsToCode: address.number
        },
        showChangeShipTo: false,
        oneTimeAddress: {
          name: address.name,
          addressLine1: address.addressLine1,
          addressLine2: address.addressLine2,
          addressLine3: address.addressLine3,
          addressLine4: address.addressLine4,
          postalCode: address.postalCode,
          stateCode: address.stateCode
        }
      }));
    } else {
      this.setState(prevState => ({
        part: {
          ...prevState.part,
          shipToAddress: `${
            address.addressLine1
              ? `${address.addressLine1.toLocaleLowerCase()}, `
              : ''
          }${
            address.addressLine2
              ? `${address.addressLine2.toLocaleLowerCase()}, `
              : ''
          }${
            address.addressLine3
              ? `${address.addressLine3.toLocaleLowerCase()}, `
              : ''
          }${
            address.addressLine4
              ? `${address.addressLine4.toLocaleLowerCase()}, `
              : ''
          }${address.stateCode ? `${address.stateCode} ` : ''}${
            address.postalCode ? `${address.postalCode}` : ''
          }`.toLowerCase(),
          shipToName: address.name
        },
        shipsToCode: address.number.toString(),
        showChangeShipTo: false,
        oneTimeAddress: null
      }));
    }

    this.getShipFromAddresses();
  };

  private getCurrentLocation = () => {
    const currentLocation = this.state.shippingList.locations.filter(
      location => location.code === this.state.cartDeliveryLocationCode
    );

    return currentLocation[0].name;
  };

  private handleScrollToLongDesc = () => {
    this.myLongDescRef.current.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
  };

  private handleClickAddToCart = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    if (
      this.props.cartItemsCount > 0 &&
      this.state.cartDeliverMethod === 'shipping' &&
      (this.state.deliverMethod === 'pick-up' ||
        this.state.deliverMethod === 'delivery')
    ) {
      this.setState({
        showChangeDeliveryAlertModal: true,
        changeDeliveryMessage: {
          title: "You can't mix delivery methods",
          message: `Your current method is Shipping. Your shopping cart will be updated to ${
            this.state.deliverMethod === 'pick-up' ? `Pick-Up` : `Delivery`
          }.`
        },
        showCartAlert: false
      });
    } else if (
      this.props.cartItemsCount > 0 &&
      this.state.cartDeliverMethod === 'pick-up' &&
      (this.state.deliverMethod === 'shipping' ||
        this.state.deliverMethod === 'delivery')
    ) {
      this.setState({
        showChangeDeliveryAlertModal: true,
        changeDeliveryMessage: {
          title: "You can't mix delivery methods",
          message: `Your current method is Pick-up. Your shopping cart will be updated to ${
            this.state.deliverMethod === 'shipping' ? `Shipping` : `Delivery`
          }.`,
          addressMessage: ` ${
            this.state.deliverMethod === 'shipping'
              ? `Extra shipping charges may apply`
              : ``
          }`
        },
        showCartAlert: false
      });
    } else if (
      this.props.cartItemsCount > 0 &&
      this.state.cartDeliverMethod === 'delivery' &&
      (this.state.deliverMethod === 'shipping' ||
        this.state.deliverMethod === 'pick-up')
    ) {
      this.setState({
        showChangeDeliveryAlertModal: true,
        changeDeliveryMessage: {
          title: "You can't mix delivery methods",
          message: `Your current method is Delivery. Your shopping cart will be updated to ${
            this.state.deliverMethod === 'shipping' ? `Shipping` : `Pick-Up`
          }.`,
          addressMessage: ` ${
            this.state.deliverMethod === 'shipping'
              ? `Extra shipping charges may apply`
              : ``
          }`
        },
        showCartAlert: false
      });
    } else if (
      this.props.cartItemsCount > 0 &&
      this.state.cartDeliverMethod === 'shipping' &&
      (this.state.cartDeliveryLocationCode !== this.state.shipsToCode ||
        this.state.oneTimeAddress)
    ) {
      this.setState({
        showChangeDeliveryAlertModal: true,
        changeDeliveryMessage: {
          title: 'You can’t have multiple shipping addresses per cart',
          subtitle: 'Your current shipping address is:',
          currentAddress: this.state.lastShipAddress,
          message: `The new shipping address will be updated in the cart to:`,
          address: this.state.part.shipToAddress,
          addressMessage: 'Extra shipping charges may apply'
        },
        showCartAlert: false
      });
    } else if (
      this.props.cartItemsCount > 0 &&
      this.state.cartDeliverMethod === 'pick-up' &&
      this.state.cartDeliveryLocationCode !== this.state.pickUpToCode
    ) {
      this.setState({
        showChangeDeliveryAlertModal: true,
        changeDeliveryMessage: {
          title: 'You can’t have multiple pickup locations in one cart',
          subtitle: `Your current pick-up location is:`,
          currentAddress: this.getCurrentLocation(),
          message: `The Pick-Up Store will be updated in the Shopping Cart to:`,
          address: this.state.part.pickUpTo,
          addressMessage:
            'This may affect the availability of some of the items in the cart. Please re-check the items in your new pickup location before submitting the order.'
        },
        showCartAlert: false
      });
    } else {
      this.addToCart();
    }

    this.setState({
      shipmentMarking: '',
      claims: '',
      dispatchClaimAlert: false,
      shipmentMarkingAlert: false,
      ticketNumberAlert: false
    });
  };

  private closeChangeDeliveryAlertModal() {
    this.setState({ showChangeDeliveryAlertModal: false });
  }

  private renderChangeDeliveryAlertModal = () => {
    return this.state.showChangeDeliveryAlertModal ? (
      <Modal
        handleCloseModal={() => console.log('Modal closed')}
        showClose={false}
      >
        <div className="rp-change-delivery-alert-modal">
          <i className="rpds-warning rp-change-delivery-alert-modal--icon" />
          <h1 className="rp-change-delivery-alert-modal--title">
            {this.state.changeDeliveryMessage.title}
          </h1>
          {this.state.changeDeliveryMessage.subtitle && (
            <>
              <p className="rp-change-delivery-alert-modal--message">
                {this.state.changeDeliveryMessage.subtitle}
              </p>
              <p className="rp-change-delivery-alert-modal--address">
                {this.state.changeDeliveryMessage.currentAddress}
              </p>
            </>
          )}
          <p className="rp-change-delivery-alert-modal--message">
            {this.state.changeDeliveryMessage.message}
          </p>
          {this.state.changeDeliveryMessage.address ? (
            <p className="rp-change-delivery-alert-modal--address">
              {this.state.changeDeliveryMessage.address}
            </p>
          ) : null}
          {this.state.changeDeliveryMessage.addressMessage && (
            <p className="rp-change-delivery-alert-modal--message">
              {this.state.changeDeliveryMessage.addressMessage}
            </p>
          )}
          <section className="rp-change-delivery-alert-modal--buttons">
            <button
              className="secondary-button"
              onClick={() => {
                this.closeChangeDeliveryAlertModal();
              }}
            >
              Go back
            </button>
            <button
              className="primary-button"
              onClick={() => {
                this.addToCart();
                this.closeChangeDeliveryAlertModal();
              }}
            >
              Ok, continue
            </button>
          </section>
        </div>
      </Modal>
    ) : null;
  };

  private addToCart = (): void => {
    this.setState({
      isLoadingPartDetails: true,
      cartDeliverMethod: this.state.deliverMethod,
      cartDeliveryLocationCode:
        this.state.deliverMethod === 'shipping'
          ? this.state.shipsToCode
          : this.state.deliverMethod === 'pick-up'
          ? this.state.pickUpToCode
          : this.state.deliverToCode
    });
    if (this.state.deliverMethod === 'shipping') {
      for (const key in this.state.shipFromOrder) {
        if (this.state.shipFromOrder.hasOwnProperty(key)) {
          this.setState({ isLoadingAddToCart: true });
          cartService
            .addItem(
              this.state.claims,
              'Shipping',
              this.state.oneTimeAddress ? 'ONE' : this.state.shipsToCode,
              this.state.oneTimeAddress,
              `${this.state.selectedManufacturer.manufacturerCode}  ${this.state.part.name}`,
              this.state.shipFromOrder[key].qty < this.state.qty
                ? parseInt(this.state.shipFromOrder[key].qty, 10)
                : this.state.qty,
              this.state.rushOrder,
              this.state.shipmentMarking,
              key,
              this.state.ticketNumber,
              this.state.warrantyProviderCode
            )
            .then(res => {
              this.handleOpenCartAlert('success');
              this.setState({
                isLoadingPartDetails: false,
                isLoadingAddToCart: false,
                isAddedToCart: true
              });
              this.props.updateCart();
              const product = this.state.part;
              product['quantity'] = this.state.qty;
              product['itemId'] = res.id;
              this.props.fireProductAddedToCartEvent(product);
            })
            .catch(e => {
              if (e.toString().includes('code 409')) {
                if (
                  e.response.data ===
                  'Location does not match previous cart info'
                ) {
                  this.handleOpenCartAlert('wrongShippingAddress');
                } else {
                  this.handleOpenCartAlert('mixedCart');
                }
              } else {
                this.handleOpenCartAlert('error', e.response.data);
              }
              this.setState({ isLoadingAddToCart: false });
            });
        }
      }
    } else if (this.state.deliverMethodtab === 'delivery') {
      for (const key in this.state.deliveryFromOrder) {
        if (this.state.deliveryFromOrder.hasOwnProperty(key)) {
          this.setState({ isLoadingAddToCart: true });
          cartService
            .addItem(
              this.state.claims,
              'Delivery',
              this.state.oneTimeAddress ? 'ONE' : this.state.shipsToCode,
              this.state.oneTimeAddress,
              `${this.state.selectedManufacturer.manufacturerCode}  ${this.state.part.name}`,
              this.state.deliveryFromOrder[key].qty < this.state.qty
                ? parseInt(this.state.deliveryFromOrder[key].qty, 10)
                : this.state.qty,
              this.state.rushOrder,
              this.state.shipmentMarking,
              key,
              this.state.ticketNumber,
              this.state.warrantyProviderCode
            )
            .then(res => {
              this.handleOpenCartAlert('success');
              this.setState({
                isLoadingPartDetails: false,
                isLoadingAddToCart: false,
                isAddedToCart: true
              });
              this.props.updateCart();
              const product = this.state.part;
              product['quantity'] = this.state.qty;
              product['itemId'] = res.id;
              this.props.fireProductAddedToCartEvent(product);
            })
            .catch(e => {
              if (e.toString().includes('code 409')) {
                if (
                  e.response.data ===
                  'Location does not match previous cart info'
                ) {
                  this.handleOpenCartAlert('wrongShippingAddress');
                } else {
                  this.handleOpenCartAlert('mixedCart');
                }
              } else {
                this.handleOpenCartAlert('error', e.response.data);
              }
              this.setState({ isLoadingAddToCart: false });
            });
        }
      }
    } else {
      for (const key in this.state.pickUpFromOrder) {
        if (this.state.pickUpFromOrder.hasOwnProperty(key)) {
          let deliveryLocation = key;
          if (key === '') {
            deliveryLocation = this.state.shippingList.defaultWarehouse
              .warehouseCode;
          }
          this.setState({ isLoadingAddToCart: true });
          cartService
            .addItem(
              this.state.claims,
              'Pick-Up',
              this.state.pickUpToCode,
              null,
              `${this.state.selectedManufacturer.manufacturerCode}  ${this.state.part.name}`,
              this.state.pickUpFromOrder[key].qty < this.state.qty
                ? this.state.pickUpFromOrder[key].qty
                : this.state.qty,
              this.state.rushOrder,
              this.state.shipmentMarking,
              deliveryLocation,
              this.state.ticketNumber,
              this.state.warrantyProviderCode
            )
            .then(res => {
              this.handleOpenCartAlert('success');
              this.props.updateCart();
              this.setState({
                isLoadingPartDetails: false,
                isLoadingAddToCart: false,
                isAddedToCart: true
              });
              const product = this.state.part;
              product['quantity'] = this.state.qty;
              product['itemId'] = res.id;
              this.props.fireProductAddedToCartEvent(product);
            })
            .catch(e => {
              if (e.toString().includes('code 409')) {
                if (
                  e.response.data ===
                  'Location does not match previous cart info'
                ) {
                  this.handleOpenCartAlert('wrongShippingAddress');
                } else {
                  this.handleOpenCartAlert('mixedCart');
                }
              } else {
                this.handleOpenCartAlert('error', e.response.data);
              }
              this.setState({ isLoadingAddToCart: false });
            });
        }
      }
    }
  };

  /* 
    handleOpenCartAlert
   */
  private handleOpenCartAlert = (
    type: 'success' | 'error' | 'mixedCart' | 'wrongShippingAddress',
    message?: string
  ) => {
    this.setState({
      showCartAlert: true,
      cartAlertType: type,
      cartAlertMessage: message ? message : ''
    });
  };

  /* 
    handleCloseCartAlert : close cart Alert
   */
  private handleCloseCartAlert = () => {
    this.setState({
      showCartAlert: false,
      cartAlertType: '',
      cartAlertMessage: ''
    });
  };

  /* 
    buildCartAlert: Prepares data to show on cart Alert
   */
  private buildCartAlert = () => {
    const alertConfig = {
      message: '',
      icon: '',
      type: ''
    };
    switch (this.state.cartAlertType) {
      case 'success':
        alertConfig.message = 'common.itemsAddedToCart';
        alertConfig.icon = 'rpds-check-circle';
        alertConfig.type = 'success';
        break;

      case 'error':
        alertConfig.message = this.state.cartAlertMessage
          ? this.state.cartAlertMessage
          : 'common.errorHasOcurred';
        alertConfig.icon = 'rpds-error';
        alertConfig.type = 'error';
        break;

      case 'mixedCart':
        alertConfig.message = 'partDetails.cartMixedMethodProhibited';
        alertConfig.icon = 'rpds-error';
        alertConfig.type = 'error';
        break;
      case 'wrongShippingAddress':
        alertConfig.message = 'partDetails.cartWrongAddressProhibited';
        alertConfig.icon = 'rpds-error';
        alertConfig.type = 'error';
        break;

      default:
        break;
    }

    return alertConfig;
  };

  public async componentDidMount() {
    await this.getPartDetails();
    await this.getMfc();
    this.setState({
      deliverMethod: this.state.cartDeliverMethod,
      lastShipAddress: this.state.part.shipToAddress
    });
    this.props.fireProductDetailEvent(this.state.part);
  }

  public componentDidUpdate(prevProps: any) {
    if (
      prevProps.match.params.partNumber !== this.props.match.params.partNumber
    ) {
      this.setState(
        {
          ...this.initialState(),
          isLoadingPartDetails: true,
          showCartAlert: false
        },
        async () => {
          await this.getPartDetails();
          await this.getMfc();
          this.props.fireProductDetailEvent(this.state.part);
        }
      );
    }
  }

  public componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  public handleWindowSizeChange = () => {
    const isMob = isMobile();
    if (isMob !== this.state.isMobile) {
      this.setState({ isMobile: isMob });
    }
  };

  private setAddToCartState = (value: boolean) => {
    this.setState({
      isAddedToCart: value
    });
  };

  private renderDesktop = () => {
    return (
      <PartDetailsDesktop
        manufacturers={this.state.manufacturers}
        orgPartnum={this.state.orgPartnum}
        orgPartmfc={this.state.orgPartmfc}
        selectedManufacturer={this.state.selectedManufacturer}
        onSelectMfc={this.onSelectMfc}
        qty={this.state.qty}
        shipmentMarking={this.state.shipmentMarking}
        ticketNumber={this.state.ticketNumber}
        warrantyProvider={this.state.warrantyProvider}
        claims={this.state.claims}
        backorder={this.state.backorder}
        rushOrder={this.state.rushOrder}
        deliverMethod={this.state.deliverMethodtab}
        part={this.state.part}
        handleChangeShipFrom={this.handleShowChangeShipFrom}
        handleChangeShipTo={this.handleShowChangeShipTo}
        handleChangePickUp={this.handleShowChangePickUp}
        handleShipmentMarkingChange={this.handleShipmentMarkingChange}
        handleTicketNumberChange={this.handleTicketNumberChange}
        handleWarrantyProviderChange={this.handleWarrantyProviderChange}
        handleClaimsChange={this.handleClaimsChange}
        handleRushOrderChange={this.handleRushOrderChange}
        handleDeliverMethodChange={this.handleDeliverMethodChange}
        handleAddToCart={this.handleClickAddToCart}
        isLoadingAddToCart={this.state.isLoadingAddToCart}
        addedToCart={this.state.showCartAlert}
        cartAlertType={this.state.cartAlertType}
        defaultWarehouse={this.state.shippingList.defaultWarehouse}
        supplierQuantity={this.state.part.supplierQuantity}
        // Pick-Up
        pickUpAddresses={this.state.shippingList.pickUpList}
        onClosePickUp={this.handleShowChangePickUp}
        handleChangePickUpTab={this.handlePickUpSuppliedFromChange}
        selectedShipFrom={this.state.pickUpFromOrder}
        selectedPickUp={this.state.pickUpToCode}
        // Ship From
        shipFromAddresses={
          this.state.shippingList && env.REACT_APP_BASE_ENVIRONMENT === 'CA'
            ? this.state.shippingList.pickUpList
            : this.state.shippingList.shippingList
        }
        onCloseShipFrom={this.handleCloseChangeDeliverMethod}
        handleChangeShipFromTab={this.handleChangeShipFrom}
        type={this.state.deliverMethod}
        buttonVerbiage={i18n.t('common.changeStore')}
        selectedAddresses={this.state.shipFromOrder}
        setAddToCartState={this.setAddToCartState}
        isAddedToCart={this.state.isAddedToCart}
        setResetPickUpAction={this.setResetPickUpAction}
        getPickUpAddresses={this.getPickUpAddresses}
        getShipFromAddresses={this.getShipFromAddresses}
        cartDeliverMethod={this.state.cartDeliverMethod}
        replacementMfc={this.state.part.replacementMfc}
        replacementPart={this.state.part.replacementPart}
        alternateProductNumber={this.state.part.alternateproductnumber}
        alternateProductManufacturer={this.state.part.alternatemfc}
        oemProductNumber={this.state.part.oemProductNumber}
        oemProductManufacturer={this.state.part.oemProductManufacturer}
        handleDeliveryChange={this.handleDeliveryChange}
        isDelivery={this.props.userData.isDelivery}
        handleDeliverySuppliedFromChange={this.handleDeliverySuppliedFromChange}
        deliveryAddresses={this.state.shippingList.deliverList}
        deliveryFromOrder={this.state.deliveryFromOrder}
        selectedDelivery={this.state.deliverToCode}
        handleScrollToLongDesc={this.handleScrollToLongDesc}
        category= {this.state.part?.category?.trim()}
      />
    );
  };

  private renderMobile = () => {
    return (
      <PartDetailsMobile
        manufacturers={this.state.manufacturers}
        selectedManufacturer={this.state.selectedManufacturer}
        onSelectMfc={this.onSelectMfc}
        qty={this.state.qty}
        shipmentMarking={this.state.shipmentMarking}
        ticketNumber={this.state.ticketNumber}
        warrantyProvider={this.state.warrantyProvider}
        claims={this.state.claims}
        backorder={this.state.backorder}
        rushOrder={this.state.rushOrder}
        deliverMethod={this.state.deliverMethod}
        part={this.state.part}
        handleChangeShipFrom={this.handleShowChangeShipFrom}
        handleChangeShipTo={this.handleShowChangeShipTo}
        handleChangePickUp={this.handleShowChangePickUp}
        handleQtyChange={this.handleQtyChange}
        handleShipmentMarkingChange={this.handleShipmentMarkingChange}
        handleTicketNumberChange={this.handleTicketNumberChange}
        handleWarrantyProviderChange={this.handleWarrantyProviderChange}
        handleClaimsChange={this.handleClaimsChange}
        handleRushOrderChange={this.handleRushOrderChange}
        handleDeliverMethodChange={this.handleDeliverMethodChange}
        handleAddToCart={this.handleClickAddToCart}
        isLoadingAddToCart={this.state.isLoadingAddToCart}
        addedToCart={this.state.showCartAlert}
        cartAlertType={this.state.cartAlertType}
        // Pick Up
        pickUpAddresses={this.state.shippingList.pickUpList}
        // Ship From
        shipFromAddresses={
          this.state.shippingList && env.REACT_APP_BASE_ENVIRONMENT === 'CA'
            ? this.state.shippingList.pickUpList
            : this.state.shippingList.shippingList
        }
        defaultWarehouse={this.state.shippingList.defaultWarehouse}
        supplierQuantity={this.state.part.supplierQuantity}
        setAddToCartState={this.setAddToCartState}
        isAddedToCart={this.state.isAddedToCart}
        handleChangePickUpTab={this.handlePickUpSuppliedFromChange}
        selectedShipFrom={this.state.pickUpFromOrder}
        selectedPickUp={this.state.pickUpToCode}
        type={this.state.deliverMethod}
        selectedAddresses={this.state.shipFromOrder}
        handleChangeShipFromTab={this.handleChangeShipFrom}
        setResetPickUpAction={this.setResetPickUpAction}
        getPickUpAddresses={this.getPickUpAddresses}
        getShipFromAddresses={this.getShipFromAddresses}
        cartDeliverMethod={this.state.cartDeliverMethod}
        replacementMfc={this.state.part.replacementMfc}
        replacementPart={this.state.part.replacementPart}
        alternateProductNumber={this.state.part.alternateproductnumber}
        alternateProductManufacturer={this.state.part.alternatemfc}
        oemProductNumber={this.state.part.oemProductNumber}
        oemProductManufacturer={this.state.part.oemProductManufacturer}
        getDeliveryFromAddresses={this.getDeliveryAddresses}
        handleDeliveryChange={this.handleDeliveryChange}
        isDelivery={this.props.userData.isDelivery}
        handleDeliverySuppliedFromChange={this.handleDeliverySuppliedFromChange}
        deliveryAddresses={this.state.shippingList.deliverList}
        deliveryFromOrder={this.state.deliveryFromOrder}
        selectedDelivery={this.state.deliverToCode}
        handleScrollToLongDesc={this.handleScrollToLongDesc}
        category= {this.state.part?.category?.trim()} 
      />
    );
  };

  private renderChangePickUp() {
    return (
      <ProductPickUpModal
        show={this.state.showChangePickUp}
        onClose={this.handleShowChangePickUp}
        defaultWarehouse={this.state.shippingList.defaultWarehouse}
        supplierQuantity={this.state.part.supplierQuantity}
        deliverAddressesList={this.state.shippingList.allPickupList}
        handleChangePickUp={this.handleChangePickUp}
        selectedPickUp={this.state.pickUpToCode}
      />
    );
  }

  private renderRelatedItems = () => {
    const { t } = this.props;
    return (
      <React.Fragment>
        {/* <div className="rp-part-view--carousel-title">
          {t('common.customerAlsoViewTxt')}:
        </div> */}
        <TopProductCardsCarousel />
      </React.Fragment>
    );
  };

  private renderLoader = () => {
    return (
      <div className="loader-container">
        <Loader />
      </div>
    );
  };

  private renderNotFound = () => {
    return <div className="rp-part-view--not-found"> {this.state.errorMessage || 'Part Not Found'}</div>;
  };

  private renderAddressNotFound = () => {
    return <div className="rp-part-view--not-found">{i18n.t('general.shippingAddrNotFound')}</div>;
  };

  private renderForBuyThisPart = () => {
    return <div className="rp-part-view--not-found">{i18n.t('general.forThisPart')} #{this.props.match.params.partNumber}</div>;
  };

  private renderUser = () => {
    return goToLogin();
  };

  public render() {
    const { t } = this.props;
    const userLoggedIn = localStorage.getItem('activeAccount');
    const alertConfig = this.buildCartAlert();
    return (
      <div className="rp-part-view Roboto">
        <div className="rp-part-view--cart-alert">
          {this.state.dispatchClaimAlert ? (
            <Alert
              styleClass="addToCartAlert"
              message={
                // 'Maximum allowable length for Dispatch/Claims marking is 15 characters'
                `${t('productFieldErrors.maxDispatchClaimsMarkingErr', {
                  count: 15
                })}`
              }
              icon={'rpds-warning'}
              handleCloseAlert={() =>
                this.setState({ dispatchClaimAlert: false })
              }
              type={'warning'}
            />
          ) : null}
          {this.state.shipmentMarkingAlert && (
            <Alert
              styleClass="addToCartAlert"
              message={
                // 'Maximum allowable length for Shipment marking is 30 characters'
                `${t('productFieldErrors.maxShipmentCharacterErr', {
                  count: 30
                })}`
              }
              icon={'rpds-warning'}
              handleCloseAlert={() =>
                this.setState({ shipmentMarkingAlert: false })
              }
              type={'warning'}
            />
          )}
          {this.state.ticketNumberAlert && (
            <Alert
              styleClass="addToCartAlert"
              message={
                // 'Maximum allowable length for Ticket/Dispatch number is 10 characters'
                `${t('productFieldErrors.maxTicketCharactersErr', {
                  count: 10
                })}`
              }
              icon={'rpds-warning'}
              handleCloseAlert={() =>
                this.setState({ ticketNumberAlert: false })
              }
              type={'warning'}
            />
          )}
          {this.state.showCartAlert ? (
            <Alert
              styleClass="addToCartAlert"
              message={t(alertConfig.message)}
              icon={alertConfig.icon}
              handleCloseAlert={this.handleCloseCartAlert}
              type={alertConfig.type}
            >
              {this.state.cartAlertType === 'success' ? (
                <a
                  href={cartUrl()}
                  onClick={goToCart}
                  className="goToCartLink"
                >{`${t('menu.goTo')} ${t('common.cart')}`}</a>
              ) : (
                <React.Fragment />
              )}
            </Alert>
          ) : (
            <React.Fragment />
          )}
        </div>
        {this.renderChangeDeliveryAlertModal()}
        {this.renderChangePickUp()}
        {this.state.showChangeShipTo ? (
          <ShippingToChange
            handleChangeAddress={this.handleChangeShipTo}
            handleCloseMenu={this.handleShowChangeShipTo}
          />
        ) : (
          <React.Fragment>
            <Breadcrumbs hideOnMobile={true}>
              {t('common.home')} /{' '}
              {decodeURIComponent(this.props.match.params.partNumber)}
            </Breadcrumbs>
             { this.state.invalidAddressEncounter
                ? this.renderAddressNotFound()
                :
            <div className="rp-part-view--part-details">

              {!userLoggedIn
                ? this.renderUser()
                : this.state.isLoadingPartDetails && this.renderLoader()}
              {this.state.notFound
                ? this.renderNotFound()
                : this.state.isMobile
                ? this.renderMobile()
                : this.renderDesktop()}
            </div>
             }
            { this.state.part.longDesc!=="" && !this.state.invalidAddressEncounter &&
            <div ref={this.myLongDescRef} className="rp-part-view--part-details">
              <div className='rp-part-details-product-desc'>
                <div className='rp-part-details-desktop-product-desc-name'>Product Description</div>
                <div className='rp-part-details-desktop-product-desc-text' dangerouslySetInnerHTML={{ __html: 
                  (this.state.part.weight && parseFloat(this.state.part.weight) > 0 ? `<strong>Weight:</strong> ${this.state.part.weight} <br>` : '') +
                  (Number(this.state.part.length || 0) > 0 ||
                  Number(this.state.part.width || 0) > 0 ||
                  Number(this.state.part.height || 0) > 0 ? `<strong>${i18n.t('common.dimesions')}:</strong> 
                  ${this.state.part.length}" L x  ${this.state.part.width}" W x  ${this.state.part.height}" H <br>` : '') +
                  (this.state.part.longDesc || '')
                  }}/>
              </div>
            </div>
            }
            {this.renderRelatedItems()}
            
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default PartView;
